<ion-card class="audio-card" *ngIf="smallVersion">
  <div class="audio-player-ui-small">
    <ion-grid>
      <ion-row>
        <ion-col size="2">
          <img class="cover-small" [src]="image | image:'evento'" alt="Album Cover" />
        </ion-col>

        <ion-col size="7">
          <div class="song-info-small">
            <h3 class="title">{{ nome ? nome : ('Ouça Agora' | translate) }}</h3>
          </div>
        </ion-col>

        <ion-col size="3" (click)="baixar()" class="icon-download">
          <div>
            <i class="fa-light fa-circle-down"></i>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>

    <div class="progress" (click)="onSeek($event)" (mousedown)="startSeek($event)" (mousemove)="seekMove($event)"
      (mouseup)="endSeek($event)" (mouseleave)="endSeek($event)">
      <div class="bar">
        <div class="fill" [style.width.%]="(mediaSecAtual / duracaoAudio) * 100"></div>
      </div>

      <div class="times">
        <span>{{ formatarSegundos(mediaSecAtual) }}</span>
        <span>{{ duracaoAudio > 0 ? formatarSegundos(duracaoAudio) : '0:00' }}</span>
      </div>
    </div>

    <div class="controls">
      <i class="fa-solid fa-backward" (click)="back()"></i>
      <i [ngClass]="playing ? 'fa fa-pause' : 'fa fa-play'" class="play" (click)="togglePlay()"></i>
      <i class="fa-solid fa-forward" (click)="next()"></i>
    </div>
  </div>
</ion-card>

<div class="audio-player-ui" *ngIf="!smallVersion">
  <img class="cover" [src]="image | image:'evento'" alt="Album Cover" />

  <div class="song-info">
    <h3 class="title">{{ nome }}</h3>
  </div>

  <div class="progress" (click)="onSeek($event)" (mousedown)="startSeek($event)" (mousemove)="seekMove($event)"
    (mouseup)="endSeek($event)" (mouseleave)="endSeek($event)">
    <div class="bar">
      <div class="fill" [style.width.%]="(mediaSecAtual / duracaoAudio) * 100"></div>
    </div>

    <div class="times">
      <span>{{ formatarSegundos(mediaSecAtual) }}</span>
      <span>{{ duracaoAudio > 0 ? formatarSegundos(duracaoAudio) : '0:00' }}</span>
    </div>
  </div>

  <div class="controls" style="padding-left: 30px;">
    <i class="fa-solid fa-backward" (click)="back()"></i>
    <i [ngClass]="playing ? 'fa fa-pause' : 'fa fa-play'" class="play" (click)="togglePlay()"></i>
    <i class="fa-solid fa-forward" (click)="next()"></i>
    <i class="fa-light fa-circle-down icon-download" (click)="baixar()"></i>
  </div>
</div>